import { MuiTypography } from '@/features/shared/material-ui';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { AccountMenuSection } from '../AccountMenu.interfaces';
import AccountNavigationItem from './AccountNavigationItem';
import useAccountNavigationSectionStyles from './AccountNavigationSection.styles';

const AccountNavigationSection = ({ title, links }: AccountMenuSection) => {
  const classes = useAccountNavigationSectionStyles();
  const location = useLocation();
  const isCurrentLocation = (linkRef: string) => linkRef.includes(location.pathname);

  return (
    <div className={classes.root}>
      <MuiTypography className={classes.title} variant="overline" component="h4">
        <small>{title}</small>
      </MuiTypography>
      <div>
        {links?.map((link, index) => (
          <div className={classes.navItemWrapper} key={index}>
            <AccountNavigationItem link={link} selected={isCurrentLocation(link.href || '')} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountNavigationSection;
